module.exports = __webpack_public_path__ + "chevron-left-pipe.svg?ddae4ffa2a795474d2b8371f4fcdf9a6";